export default "/images/vendor/flag-icons/flags/1x1/tz.svg?3dcba19bd6519be1d537ac6bf56246a4";